export default __webpack_public_path__ + "static/media/github-icon.93350365.svg";